"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Client = _interopRequireDefault(require("./Client"));

var _utils = require("./_utils");

/**
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2018 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe Inc. and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe Inc.
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Inc.
 */

/**
 * The Collaborators class handles operation around collaborators.
 */
var Collaborators = /*#__PURE__*/function () {
  function Collaborators() {
    (0, _classCallCheck2["default"])(this, Collaborators);
  }

  (0, _createClass2["default"])(Collaborators, [{
    key: "update",

    /**
     * Update a collaborator
     * @param {String} resourceUrl - CC Storage path (path based or ID-based)
     * @param {String} userId - AdobeID of collaborator whose privileges need to be updated
     * @param {String} role - Updated role to be granted to the collaborator
     *
     * @returns {Promise} A Promise that updates the collaborator for a particular resource URL
     */
    value: function update(resourceUrl, userId, role) {
      if (resourceUrl && userId && role && resourceUrl.trim() !== '' && userId.trim() !== '' && role.trim() !== '') {
        var body = [{
          role: role,
          collaborator: userId
        }];
        return this.batchUpdate(resourceUrl, body);
      }
    }
    /**
     * Batch update collaborators
     * @param {String} resourceUrl - CC Storage path (path based or ID-based)
     * @param {Array<{role: string, collaborator: string}>} collaborators - list of collaborators whose roles need to be updated
     * 
     * @returns {Promise} A Promise that updates the collaborators for a particular resource URL
     */

  }, {
    key: "batchUpdate",
    value: function batchUpdate(resourceUrl, collaborators) {
      if (resourceUrl && resourceUrl.trim() !== '' && Array.isArray(collaborators)) {
        return _Client["default"].instance.fetch({
          type: 'collaborators.update',
          urlPath: '/collaborators/' + (0, _utils.encodeURIComponentEachSubdomain)((0, _utils.getUrlPath)(resourceUrl)),
          method: 'PUT',
          body: collaborators
        });
      }
    }
    /**
     * Delete a collaborator
     * @param {String} resourceUrl - CC Storage path (path based or ID-based)
     * @param {String} userId - AdobeID of collaborator whose privileges need to be removed
     *
     * @returns {Promise} A Promise that removes the collaborator for a particular resource URL
     */

  }, {
    key: "delete",
    value: function _delete(resourceUrl, userId) {
      if (resourceUrl && userId && resourceUrl.trim() !== '' && userId.trim() !== '') {
        var encodedRequestURI = "/collaborators/".concat((0, _utils.encodeURIComponentEachSubdomain)((0, _utils.getUrlPath)(resourceUrl)), "?collaborator=").concat(encodeURIComponent(userId));
        return _Client["default"].instance.fetch({
          type: 'collaborators.delete',
          urlPath: encodedRequestURI,
          method: 'DELETE'
        });
      }
    }
    /**
     * Delete all collaborators
     * @param {String} resourceUrl - CC Storage path (path based or ID-based)
     *
     * @returns {Promise} A Promise that removes all the collaborators for a particular resource URL
     */

  }, {
    key: "deleteAll",
    value: function deleteAll(resourceUrl) {
      if (resourceUrl && resourceUrl.trim() !== '') {
        return _Client["default"].instance.fetch({
          type: 'collaborators.deleteAll',
          urlPath: '/collaborators/' + (0, _utils.encodeURIComponentEachSubdomain)((0, _utils.getUrlPath)(resourceUrl)),
          method: 'DELETE'
        });
      }
    }
  }]);
  return Collaborators;
}();
/**
 * Exports the Collaboration class.
 */


var _default = Collaborators;
exports["default"] = _default;